import React, { useState } from 'react';
import { services } from '../../constants/data';

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    
    if (term.length > 2) {
      const results = services.filter(service =>
        service.title.toLowerCase().includes(term.toLowerCase()) ||
        service.description.toLowerCase().includes(term.toLowerCase()) ||
        service.category.toLowerCase().includes(term.toLowerCase())
      );
      setSearchResults(results);
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  };

  return (
    <div className="position-relative">
      <div className="input-group">
        <input
          type="search"
          className="form-control"
          placeholder="Search services..."
          value={searchTerm}
          onChange={handleSearch}
          aria-label="Search services"
        />
        <button className="btn btn-outline-light" type="button">
          <i className="bi bi-search"></i>
        </button>
      </div>
      
      {showResults && searchResults.length > 0 && (
        <div className="search-results position-absolute top-100 start-0 end-0 bg-white border rounded shadow-lg mt-1 z-3">
          {searchResults.map(service => (
            <div key={service.id} className="p-3 border-bottom">
              <div className="d-flex align-items-center">
                <i className={`bi ${service.icon} text-primary me-3`}></i>
                <div>
                  <h6 className="mb-1">{service.title}</h6>
                  <p className="text-muted small mb-0">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      
      {showResults && searchResults.length === 0 && (
        <div className="search-results position-absolute top-100 start-0 end-0 bg-white border rounded shadow-lg mt-1 z-3 p-3">
          <p className="text-muted mb-0">No services found</p>
        </div>
      )}
    </div>
  );
};

export default SearchBar;